import "../styles/default.scss";

import React from "react";
import { compose } from "redux";

import { UrlProvider } from "../../../../../api/UrlProvider";
import withAnalysisCategories from "../../../../../hocs/withAnalysisCategories";
import withGlobalConfigFields from "../../../../../hocs/withGlobalConfigFields";
import withTranslations from "../../../../../hocs/withTranslations";
import withUserData from "../../../../../hocs/withUserData";
import useGetRequest from "../../../../../hooks/useGetRequest";
import { globalConfigFields } from "../../../../../redux/modules/globalConfig";
import Loader from "../../../common/Loader";
import ContentWrapper from "../components/ContentWrapper";
import AnalysisContentFactory from "../components/AnalysisContentFactory";
import SignInRequiredPage from "../../../landingPage/pages/Plans/components/SignInRequiredPage/SignInRequiredPage";
import ErrorPage from "../../../landingPage/pages/Plans/components/ErrorPage/ErrorPage";
import NoPermissionModal from "../../Plans/components/NoPermissionModal";
import { withRouter } from "react-router-dom";

function SingleAnalysisPage({
  match,
  translate,
  locale,
  analysisCategories,
  isInsiderAnalysis = false,
  history
}) {
  const { id } = match.params;

  const { response, loading, error } = useGetRequest({
    urlPath: isInsiderAnalysis
      ? "app.insiderStockAnalysis.get"
      : "app.stockAnalysis.get",
    variables: {
      stockAnalysisId: id
    },
    locale,
    skipAccessCheck: true
  });

  const contentWrapperProps = {
    className: "analysis-content",
    stock: response?.stock,
    isInsiderAnalysis
  };

  if (loading) {
    return (
      <ContentWrapper {...contentWrapperProps}>
        <Loader small />
      </ContentWrapper>
    );
  }

  if (error) {
    switch (error?.response?.status) {
      case 401:
        return <SignInRequiredPage />;
      case 403: {
        return (
          <NoPermissionModal
            permissions={error?.response?.data?.permissions}
            onClose={() => {
              history.push(UrlProvider.getUrl("fe.home", { locale }));
            }}
          />
        );
      }
      default:
        return <ErrorPage />;
    }
  }

  if (!response) {
    return (
      <ContentWrapper {...contentWrapperProps}>
        <h2>{translate("Analysis not found")}</h2>
      </ContentWrapper>
    );
  }

  const { category } = response;

  const analysisCategory = analysisCategories?.find(c => c.id === category);

  return (
    <ContentWrapper {...contentWrapperProps}>
      <AnalysisContentFactory
        response={response}
        analysisCategory={analysisCategory}
      />
    </ContentWrapper>
  );
}

export default compose(
  withTranslations,
  withAnalysisCategories,
  withUserData,
  withGlobalConfigFields([globalConfigFields.OFFER_URL]),
  withRouter
)(SingleAnalysisPage);
